export { CursorClick as default } from './CursorClick';
